import useStores from 'shared/hooks/use-stores';
export default function useUser() {
  var _useStores = useStores(),
    User = _useStores.User;
  return User;
}